import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { PoseidonUrlFormBase } from '../../FormBases';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  error: FieldError | undefined;
};

/**
 * 新規登録モーダル用の顧客環境URLのフォームです。
 */
export const PoseidonUrlForm: FC<Props> = ({ register, error }) => (
  <FormControl isInvalid={Boolean(error)}>
    <FormLabel>顧客環境URL</FormLabel>
    <PoseidonUrlFormBase register={register} />
    <FormErrorMessage>{error && error.message}</FormErrorMessage>
  </FormControl>
);
